<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>

    </div>
    <div class="icerik">
      <Yukleniyor :data="lo" text="Lütfen Bekleyiniz."></Yukleniyor>
      <div class="raporbloksabitle">
        <el-row :gutter="24">

          <el-form :rules="FormHata" :model="Form"
                   @submit.prevent.native="Getir"
                   ref="RaporForm">


            <el-col :span="4">
              <el-form-item label="Rapor Tarih Aralığı" prop="Tarih">
                <el-date-picker
                  :clearable="false"
                  v-model="Form.Tarih"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="Başlangıç Tarihi"
                  end-placeholder="Bitiş Tarihi"
                  format="dd.MM.yyyy"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="3" :offset="17">
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-alert
            v-if="!tableDisplay"
            title="Filtreleme Yapınız"
            type="info"
            :closable="false"
            description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
            v-if="tableDisplay"
            class="table-xs"
            :data="tableData"
            style="width: 100%"
            width="100%"
            :height="Height"
          >
            <el-table-column
              label="İşlem Tarihi"
              prop="tarih"
              width="150">
            </el-table-column>
            <el-table-column
              label="Başlık"
              prop="SmsBaslik"
              width="100">
            </el-table-column>
            <el-table-column
              label="Kredi"
              prop="kredi"
              width="100">
            </el-table-column>
            <el-table-column
              label="Telefon"
              prop="telefon"
              width="100">
            </el-table-column>
            <el-table-column
              label="İçerik"
              prop="icerik">
            </el-table-column>
            <el-table-column
              label="Durum"
              prop="api_durum"
              width="150">
            </el-table-column>


          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

  import Yukleniyor from "../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        Height: 0,
        lo: false,
        Yetki: false,
        Kaydet: false,
        Sayfa: {
          Adi: 'Sms Raporu',
          ButtonAdi: 'Uygula',
          FiltreAdi: 'Filtreleme',
        },
        Form: {
          Tarih: [],
        },
        FormHata: {
          Tarih: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
        tableData: [],
        tableDisplay: false,
      }
    },
    methods: {

      Getir() {
        this.$refs['RaporForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {...this.Form, path: '_a/smsliste'})
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.tableData = response.Liste;

                  if (this.tableData)
                    this.tableDisplay = true;
                  else
                    this.$message.error("Kayıt Bulunamadı");

                  this.Height = window.innerHeight - 220;
                } else {
                  this.$message.error(response.Mesaj);
                  this.hata = response.Hata;
                }
              })
          }
        })
      },


    },
    created() {
      //this.SayfaYukle();
      var Gun = new Date();
      //this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
      //this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
      this.Form.Tarih[0] = new Date();
      this.Form.Tarih[1] = new Date();
    },

  }
</script>



// WEBPACK FOOTER //
// src/pages/_a/Sms.vue